import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks the copy of the API key',
  name: 'account_api_key_copy',
  params: [
    {
      description: 'The ID of the API key',
      name: 'api_key_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
